import React, { useImperativeHandle, useRef } from "react";
import { Input as InputLib, InputRef } from "@npm_leadtech/qr-ui-components";

import { InputAdapterProps } from "./types";

import { useAdapterLogic } from "./hooks";
import { getInputIcon } from "@/utils/iconMap";

export const InputAdapter = React.forwardRef<InputRef, InputAdapterProps>((props, ref) => {
  const internalRef = useRef<InputRef>(null);
  const prefix = props.iconName ? getInputIcon(props.iconName) : props.prefix;

  useImperativeHandle(ref, () => internalRef.current as InputRef, []);

  const inputProps = useAdapterLogic(props, internalRef);

  return (
    <InputLib
      {...inputProps}
      prefix={prefix}
    />
  );
});

InputAdapter.displayName = "InputAdapter";
